<template>
  <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
    <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
      <el-col class="flex-box al-c" :span="4">
        <el-button type="primary" @click="initPage">查询</el-button>
      </el-col>
    </Sift>
    
    <div class="table-con">
      <el-table class="w100 mt20 table" header-row-class-name="table-head" row-class-name="cu-p" stripe :data="list" height="100%">
        <el-table-column align="center" label="序号" width="50px">
          <template slot-scope="scope">
            {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="serveName" label="服务名称"></el-table-column>
        <el-table-column align="center" prop="proTitle" label="事务标题"></el-table-column>
        <el-table-column align="center" prop="exceptionExplain" label="异常说明"></el-table-column>
        <el-table-column align="center" label="申请时间">
          <template slot-scope="scope">
            {{ scope.row.startTime | filterDate('yyyy-MM-dd hh:mm') }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="userName" label="申请人"></el-table-column>
        <el-table-column align="center" prop="refuseIP" label="操作">
          <template slot-scope="scope">
            <div class="to-use">
              <span class="info" @click="goInfo(scope.row.proId)">详情</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sift from "@/components/sift/Sift";

export default {
  name: "Serve",
  components: {
    Sift
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {
    ...mapGetters(["userToken"])
  },
  created() {},
  mounted() {
    this.fetchSiftData()
  },
  destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData() {
      this.loading = true;

      setTimeout(() => {
        this.siftData = [
          {
            type: "text",
            key: "name",
            label: "服务名称",
            placeholder: "",
            default: ""
          },
          {
            type: "text",
            key: "title",
            label: "事务标题",
            placeholder: "",
            default: ""
          }
        ];

        this.$nextTick(() => {
          this.initPage();
        });
      }, 500);
    },

    // 获取列表
    getListFn () {
      let selectData = this.$refs.needSift.getValue();  // 获取搜索条件的值
      let data = {
        serveName: selectData.name,
        proTitle: selectData.title,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };

      this.$http.get( "/overtime/list", { params: data } )
      .then( ({ data }) => {
        if ( data.resCode === 0 ) {
          this.list = data.resData.list;
          this.total = data.resData.total;
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      })
    },

    // 详情
    goInfo (proId) {
      let urlArr = this.$http.defaults.baseURL.split(":")
      let url = urlArr[0] + urlArr[1] + ":8088/portal/r/w?sid=#{" + this.userToken + "}&cmd=CLIENT_BPM_FORM_MAIN_PAGE_OPEN&processInstId=#{" + proid + "}";
      window.location = url;
    },

    // 默认页面数据
    initPage() {
      this.pageNum = 1;
      this.getListFn();
    },

    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
  .table-con {
    height: calc(100vh - 270px);
  }
  
  .to-use {
    width: 100%;
  }

  .to-use span {
    padding: 0 8px;
    display: inline-block;
  }

  .to-use .info {
    color: #409EFF;
  }

  .to-use .delete {
    color: #cdcdcd;
  }

  .to-use .info:hover {
    color: #336ab1;
  }

  .to-use .delete:hover {
    color: #606266;
  }
</style>
